(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _general = require("./parts/general.js");
var _introvideo = require("./parts/introvideo.js");
var _cover = require("./parts/cover.js");
var _letter = require("./parts/letter.js");
var _lettertext = require("./parts/lettertext.js");
var _fourtieth = require("./parts/fourtieth.js");
var _grandchallenge = require("./parts/grandchallenge.js");
var _newfrontiers = require("./parts/newfrontiers.js");
var _newgrandchallenge = require("./parts/newgrandchallenge.js");
var _agp = require("./parts/agp.js");
var _getcontent = require("./parts/getcontent.js");
var _fellows = require("./parts/fellows.js");
var _eac = require("./parts/eac.js");
var _forecasting = require("./parts/forecasting.js");
var _briefings = require("./parts/briefings.js");
var _happy = require("./parts/happy.js");
var _trends = require("./parts/trends.js");
var _research = require("./parts/research.js");
var _wealth = require("./parts/wealth.js");
var _ncgrowth = require("./parts/ncgrowth.js");
var _scholars = require("./parts/scholars.js");
var _dean = require("./parts/dean.js");
var _events = require("./parts/events.js");
var _engagement = require("./parts/engagement.js");
var _footer = require("./parts/footer.js");
window.addEventListener("load", function (event) {
  console.log('LOADING');
  var screen = gsap.timeline();
  screen.to(".lds-ripple", {
    opacity: 0,
    duration: 0.5,
    ease: "power4.in"
  }).to("#screen", {
    opacity: 0,
    duration: 2,
    ease: "power4.in",
    onComplete: function onComplete(e) {
      var screen = document.getElementById('screen');
      if (screen) {
        screen.style.display = 'none';
      }
    }
  }, 0);
  (0, _general.general)();
  (0, _introvideo.introvideo)();
  (0, _getcontent.getContent)();
  (0, _cover.cover)();
  (0, _letter.letter)();
  (0, _lettertext.lettertext)();
  (0, _fourtieth.fourtieth)();
  (0, _grandchallenge.grandchallenge)();
  (0, _fellows.fellows)();
  (0, _newfrontiers.newfrontiers)();
  (0, _newgrandchallenge.newgrandchallenge)();
  (0, _agp.agp)();
  (0, _eac.eac)();
  (0, _forecasting.forecasting)();
  (0, _briefings.briefings)();
  (0, _happy.happy)();
  (0, _trends.trends)();
  (0, _research.resaearch)();
  (0, _wealth.wealth)();
  (0, _ncgrowth.ncgrowth)();
  (0, _scholars.scholars)();
  (0, _dean.dean)();
  (0, _events.events)();
  (0, _engagement.engagement)();
  (0, _footer.footer)();
  ScrollTrigger.refresh();
  //smoothScroll();
});

},{"./parts/agp.js":2,"./parts/briefings.js":3,"./parts/cover.js":4,"./parts/dean.js":5,"./parts/eac.js":6,"./parts/engagement.js":7,"./parts/events.js":8,"./parts/fellows.js":9,"./parts/footer.js":10,"./parts/forecasting.js":11,"./parts/fourtieth.js":12,"./parts/general.js":13,"./parts/getcontent.js":14,"./parts/grandchallenge.js":15,"./parts/happy.js":16,"./parts/introvideo.js":17,"./parts/letter.js":18,"./parts/lettertext.js":19,"./parts/ncgrowth.js":20,"./parts/newfrontiers.js":21,"./parts/newgrandchallenge.js":22,"./parts/research.js":23,"./parts/scholars.js":24,"./parts/trends.js":25,"./parts/wealth.js":26}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.agp = agp;
function agp() {
  console.log('2025 grandchallenge');
  var agpcontainer = gsap.timeline({
    scrollTrigger: {
      trigger: "#agp-container",
      scrub: 2,
      pin: true,
      start: "top top"
      // start: "top 10px", // when top of the element hits 20% of viewport
      // toggleActions: "play reverse play reverse", // Customize as needed
    }
  }).to("#agp-background", {
    opacity: '1',
    filter: 'blur(0px)',
    duration: 4
  }, 0).to("#agp-image img", {
    clipPath: "polygon(100% 0%, 0% 20%, 0% 90%, 100% 70%)",
    delay: 2,
    duration: 2
  }, 0).to("#agp-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.15,
    delay: 0.25,
    ease: 'power4.out'
  }, 0).to("#agp-title p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.5,
    delay: 0.45,
    ease: 'power4.out',
    stagger: 0.25
  }, 0)
  // .to(
  //     "#agp-title h3",
  //     {
  //         y: '0',
  //         opacity: '1',
  //         filter: 'blur(0px)',
  //         duration: 0.35,
  //         ease: 'power4.out',
  //     },0
  // )
  .to("#agp-image img", {
    clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
    duration: 5
  })
  // .to(
  //     "#agp-title h3",
  //     {
  //         opacity: '0',
  //         filter: 'blur(5px)',
  //         duration: 4,
  //         ease: 'power4.out',
  //         y: '-200',
  //     },4
  // )
  .to("#agp-title p", {
    opacity: '0',
    filter: 'blur(5px)',
    duration: 4,
    ease: 'power4.out',
    y: '-300'
  }, 4);
}

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.briefings = briefings;
function briefings() {
  console.log('Briefings');
  var briefingscontainer = gsap.timeline({
    scrollTrigger: {
      trigger: "#briefings-container",
      scrub: 2,
      pin: true,
      start: "top top"
    }
  }).to("#briefings-background", {
    opacity: '1',
    filter: 'blur(0px)',
    duration: 4
  }, 0).to("#briefings-image img", {
    clipPath: "polygon(100% 0%, 0% 20%, 0% 90%, 100% 70%)",
    delay: 2,
    duration: 2
  }, 0).to("#briefings-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.15,
    delay: 0.25,
    ease: 'power4.out'
  }, 0).to("#briefings-title p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.5,
    delay: 0.45,
    ease: 'power4.out'
  }, 0).to("#briefings-title h3", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.35,
    ease: 'power4.out'
  }, 0).to("#briefings-image img", {
    clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
    duration: 5
  }).to("#briefings-title p", {
    opacity: '0',
    filter: 'blur(5px)',
    duration: 4,
    ease: 'power4.out',
    y: '-200'
  }, 4);
  var briefingscontent = gsap.timeline({
    scrollTrigger: {
      trigger: "#briefings-content",
      pin: true,
      scrub: 2
    }
  }).from("#briefings-content p, #briefings-content h3", {
    ease: 'power4.out',
    duration: 2,
    opacity: 0,
    filter: 'blur(5px)',
    y: '+=800',
    stagger: 0.25
  });
  var briefingscontainer3 = gsap.timeline({
    scrollTrigger: {
      trigger: ".briefings-vid-container",
      scrub: 2,
      pin: true,
      start: "top 20%"
    }
  }).to('.briefings-vid-container h3', {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    stagger: 0.25
  }).to(".briefings-content-vid", {
    ease: 'power4.out',
    duration: 2,
    opacity: 1,
    filter: 'blur(0px)',
    y: '0',
    stagger: 0.25
  }, 0.15);
}

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cover = cover;
function cover() {
  console.log('cover');
  var cover = gsap.timeline({
    scrollTrigger: {
      trigger: "#cover",
      scrub: 2,
      pin: true
    }
  }).to("#cover-image", {
    clipPath: "polygon(0% 0%, 100% 20%, 100% 90%, 0% 70%)"
  }, 0).to("#cover-image", {
    clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"
  }).to(".cover-annual", {
    // y:"+=800",
    color: "#ffffff"
  }, 0).to("#mouse-container", {
    opacity: 0,
    y: "+=650",
    color: "#ffffff",
    filter: "blur(5px)"
  }, 0);
  var theMouse = gsap.timeline({
    scrollTrigger: {
      trigger: "#cover",
      start: "top 50",
      toggleActions: "play reverse play reverse"
    },
    repeat: -1,
    repeatDelay: 1
  }).from("#mouse-ball", {
    opacity: 0,
    y: "-=28px",
    ease: "bounce.out"
  });
}

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dean = dean;
function dean() {
  console.log('DEAN SPEAKER SERIES');
  var deancontainer = gsap.timeline({
    scrollTrigger: {
      trigger: "#dean-container",
      scrub: 2,
      pin: true,
      start: "top top"
    }
  }).to("#dean-background", {
    opacity: '1',
    filter: 'blur(0px)'
  }, 0).to("#dean-image img", {
    clipPath: "polygon(100% 0%, 0% 20%, 0% 90%, 100% 70%)",
    delay: 2
  }, 0).to("#dean-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    delay: 0.25,
    ease: 'power4.out'
  }, 0).to("#dean-title p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    delay: 0.45,
    stagger: 0.5,
    ease: 'power4.out'
  }, 0).to("#dean-image img", {
    clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
    duration: 5
  }).to("#dean-title p", {
    opacity: '0',
    filter: 'blur(5px)',
    duration: 4,
    ease: 'power4.out',
    y: '-200'
  }, 4);
  var deancontainer2 = gsap.timeline({
    scrollTrigger: {
      trigger: "#dean-content",
      start: "top 40%",
      // when top of the element hits 20% of viewport
      toggleActions: "play reverse play reverse" // Customize as needed
    }
  }).to("#dean-content img", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    ease: 'power4.out',
    stagger: 0.25
  }).to("#dean-content .name", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    ease: 'power4.out',
    stagger: 0.25
  }, 0).to("#dean-content .title", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    ease: 'power4.out',
    stagger: 0.25
  }, 0);
}

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eac = eac;
function eac() {
  console.log('EAC');
  var eaccontainer = gsap.timeline({
    scrollTrigger: {
      trigger: "#eac-container",
      scrub: 2,
      pin: true,
      start: "top top"
      // start: "top 10px", // when top of the element hits 20% of viewport
      // toggleActions: "play reverse play reverse", // Customize as needed
    }
  }).to("#eac-background", {
    opacity: '1',
    filter: 'blur(0px)',
    duration: 4
  }, 0).to("#eac-image img", {
    clipPath: "polygon(100% 0%, 0% 20%, 0% 90%, 100% 70%)",
    delay: 2,
    duration: 2
  }, 0).to("#eac-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.15,
    delay: 0.25,
    ease: 'power4.out'
  }, 0).to("#eac-title p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.5,
    delay: 0.45,
    ease: 'power4.out'
  }, 0)
  // .to(
  //     "#grandchallenge-title h3",
  //     {
  //         y: '0',
  //         opacity: '1',
  //         filter: 'blur(0px)',
  //         duration: 0.35,
  //         ease: 'power4.out',
  //     },0
  // )
  // .to(
  //     "#grandchallenge-title h2",
  //     {
  //         y: '0',
  //         opacity: '1',
  //         filter: 'blur(0px)',
  //         delay: 0.25,
  //         duration: 0.5,
  //         ease: 'power4.out',
  //     },0
  // )
  .to("#eac-image img", {
    clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
    duration: 5
  }).to("#eac-title p", {
    opacity: '0',
    filter: 'blur(5px)',
    duration: 4,
    ease: 'power4.out',
    y: '-200'
  }, 4);
  var eaccontainer2 = gsap.timeline({
    scrollTrigger: {
      trigger: "#eac-content",
      // scrub: 2,
      // pin: true,
      // markers: true,
      start: "top 40%",
      // start: "top 10px", // when top of the element hits 20% of viewport
      toggleActions: "play reverse play reverse" // Customize as needed
    }
  }).to('#eac-content p, #eac-content ul, #eac-content .eac-reports, .report', {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    stagger: 0.25
  });
  var eaccontainer3 = gsap.timeline({
    scrollTrigger: {
      trigger: ".eac-vid-container",
      scrub: 2,
      pin: true,
      start: "top 20%"
    }
  }).to('h3.eac-events', {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)'
  }).to('.eac-content-vid', {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    stagger: 0.25
  });
  var eaccontainer4 = gsap.timeline({
    scrollTrigger: {
      trigger: "#visit-eac-container",
      start: "top 80%",
      toggleActions: "play reverse play reverse" // Customize as needed
    }
  }).to('#visit-eac', {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)'
  });
}

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.engagement = engagement;
function engagement() {
  console.log('ENGAGEMENT');
  var engagementcontainer = gsap.timeline({
    scrollTrigger: {
      trigger: "#engagement-container",
      scrub: 2,
      pin: true,
      start: "top top",
      // pin when top of container hits top of viewport
      end: "bottom bottom" // unpin when bottom of container hits bottom of viewport
    }
  }).to("#engagement-background", {
    opacity: '1',
    filter: 'blur(0px)'
  }, 0).to("#engagement-image img", {
    clipPath: "polygon(100% 0%, 0% 20%, 0% 90%, 100% 70%)",
    delay: 2
  }, 0).to("#engagement-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    delay: 0.25,
    ease: 'power4.out'
  }, 0).to("#engagement-title p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    delay: 0.45,
    stagger: 0.5,
    ease: 'power4.out'
  }, 0).to("#engagement-image img", {
    clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
    duration: 5
  });
  var engagement2 = gsap.timeline({
    scrollTrigger: {
      trigger: "#engagement-content",
      start: "top 50%",
      // when top of the element hits 20% of viewport
      end: "bottom bottom+=500",
      // when bottom of the element hits the top of the viewport
      toggleActions: "play reverse play reverse",
      // Customize as needed
      pin: true,
      scrub: 2
    }
  }).to("#engagement-content p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    ease: 'power4.out',
    stagger: 0.25
  });
}

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.events = events;
function events() {
  console.log('COMING UP');
  var eventcontainerA = gsap.timeline({
    scrollTrigger: {
      trigger: "#event-container",
      scrub: 2,
      pin: true,
      start: "top top"
    }
  }).to("#event-background", {
    opacity: '1',
    filter: 'blur(0px)'
  }, 0).to("#event-image img", {
    clipPath: "polygon(100% 0%, 0% 20%, 0% 90%, 100% 70%)",
    delay: 2
  }, 0).to("#event-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    delay: 0.25,
    ease: 'power4.out'
  }, 0).to("#event-image img", {
    clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
    duration: 5
  });
  var timelines = {};
  document.querySelectorAll('.events').forEach(function (row, index) {
    var rowID = row.id;
    var timelineName = "timeline_" + index;
    timelines[timelineName] = gsap.timeline({
      scrollTrigger: {
        trigger: "#" + rowID,
        // Use the specific container as the trigger
        start: "top 30%",
        // Adjust as needed
        toggleActions: "play reverse play reverse" // Customize as needed
      }
    }).to("#" + rowID + " .card", {
      opacity: 1,
      stagger: 0.15,
      y: '0',
      ease: "power4.out",
      filter: 'blur(0px)'
    });
    ScrollTrigger.refresh();
  });
  var moreEventsB = gsap.timeline({
    scrollTrigger: {
      trigger: "#more-events",
      start: "top 90%",
      // when top of div hits center of viewport
      toggleActions: "play reverse play reverse" // Customize as needed
    }
  }).to("#more-events", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 1,
    ease: 'power4.out'
  });
}

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fellows = fellows;
function fellows() {
  console.log('fellows');
  var fellowsX = gsap.timeline({
    scrollTrigger: {
      trigger: "#landing-fellows",
      scrub: 2,
      pin: true,
      start: "top top" // when top of div hits center of viewport
    }
  }).to("#fellows-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 1,
    ease: 'power4.out'
  }).to("#fellows-title p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    delay: 0.25,
    duration: 2,
    ease: 'power4.out'
  }, 0).to(".fellow, #thanks", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 1,
    stagger: 0.25,
    ease: 'power4.out'
  });

  // const fellowsThanks = gsap
  // .timeline({
  //   scrollTrigger: {                
  //     trigger: "#thanks",
  //     start: "top 90%", // when top of div hits center of viewport
  //     toggleActions: "play reverse play reverse", // Customize as needed
  //   },
  // })  
  // .to (
  //   "#thanks",
  //   {
  //     y: '0',
  //     opacity: '1',
  //     filter: 'blur(0px)',
  //     duration: 1,
  //     ease: 'power4.out',
  //   }
  // )
}

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.footer = footer;
function footer() {
  console.log('footer');
  var footerAnim = gsap.timeline({
    scrollTrigger: {
      trigger: "#footer",
      pin: true,
      scrub: 2
    }
  }).to("#footer .logo-building-footer", {
    y: 0,
    opacity: 1,
    ease: "power4.out",
    stagger: 0.08
  }, 0).to('#footer .button, #footer-logo', {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    ease: "Expo.easeOut",
    stagger: 0.25
  }, 0.5);
}

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forecasting = forecasting;
function forecasting() {
  console.log('Forecasting');
  var forecastingcontainer = gsap.timeline({
    scrollTrigger: {
      trigger: "#forecasting-container",
      scrub: 2,
      pin: true,
      start: "top top",
      end: "bottom+=500 top"
    }
  }).to("#forecasting-background", {
    opacity: '1',
    filter: 'blur(0px)',
    duration: 4
  }, 0).to("#forecasting-image img", {
    clipPath: "polygon(100% 0%, 0% 20%, 0% 90%, 100% 70%)",
    delay: 2,
    duration: 2
  }, 0).to("#forecasting-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.15,
    delay: 0.25,
    ease: 'power4.out'
  }, 0).to("#forecasting-title p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.5,
    delay: 0.45,
    ease: 'power4.out'
  }, 0).to("#forecasting-title h3", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.35,
    ease: 'power4.out'
  }, 0).to("#forecasting-image img", {
    clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
    duration: 5
  }).to("#forecasting-title p", {
    opacity: '0',
    filter: 'blur(5px)',
    duration: 4,
    ease: 'power4.out',
    y: '-200'
  }, 4);
  var forecastingcontainer2 = gsap.timeline({
    scrollTrigger: {
      trigger: "#forecasting-content",
      start: "top 40%",
      toggleActions: "play reverse play reverse" // Customize as needed
    }
  }).to('#forecasting-content ul, #forecasting-content h3', {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    stagger: 0.25
  });
}

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fourtieth = fourtieth;
function fourtieth() {
  console.log('fourtieth');
  var fourtiethcontainer = gsap.timeline({
    scrollTrigger: {
      trigger: "#fourtieth-container",
      scrub: 2,
      pin: true
    }
  }).to("#fourtieth-background", {
    opacity: '1',
    filter: 'blur(0px)',
    duration: 4
  }, 0).to("#fourtieth-image img", {
    clipPath: "polygon(100% 0%, 0% 20%, 0% 90%, 100% 70%)",
    delay: 2,
    duration: 2
  }, 0).to("#fourtieth-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.15,
    delay: 0.25,
    ease: 'power4.out'
  }, 0).to("#fourtieth-title p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.5,
    delay: 0.45,
    ease: 'power4.out'
  }, 0).to("#fourtieth-title h2", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    delay: 0.25,
    duration: 0.5,
    ease: 'power4.out'
  }, 0).to("#fourtieth-image img", {
    clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
    duration: 5
  }).to("#fourtieth-title p", {
    opacity: '0',
    filter: 'blur(5px)',
    duration: 4,
    ease: 'power4.out',
    y: '-300'
  }, 4);
  var fourtiethcontent = gsap.timeline({
    scrollTrigger: {
      trigger: "#fourtieth-content",
      pin: true,
      scrub: 2
    }
  }).from("#fourtieth-content-vid, #fourtieth-content p", {
    ease: 'power4.out',
    duration: 2,
    opacity: 0,
    y: '+= 800',
    stagger: 0.25
  }, 0.15);
  var fourtiethcarousel = gsap.timeline({
    scrollTrigger: {
      trigger: "#fourtieth-carousel",
      pin: true,
      scrub: 2
    }
  }).from("#fourtieth-carousel .carousel", {
    ease: 'power4.out',
    duration: 2,
    opacity: 0,
    y: '+= 800'
  }, 0.15);
}

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.general = general;
function general() {
  console.log('general');
  var cta = document.getElementById('call-to-action');
  function onScroll50() {
    if (window.scrollY >= 50) {
      cta.classList.add('scrolled');
    } else {
      cta.classList.remove('scrolled');
      cta.style.marginTop = "48";
    }
  }
  window.addEventListener('scroll', onScroll50);
}

},{}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContent = getContent;
function getContent() {
  console.log('getContent');
  var endpointUrl = 'https://kenaninstitute.unc.edu/wp-json/custom/v1/yearreview25';

  // GRAND CHALLENGE
  fetch(endpointUrl).then(function (response) {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json(); // Parse the response body as JSON
  }).then(function (data) {
    // Process the data
    data.forEach(function (post, index) {
      var cards = document.getElementsByClassName('card event');
      if (cards.length) {
        var cardBody = cards[index].getElementsByClassName('card-body');
        var cardTitle = cardBody[0].getElementsByClassName('card-title');
        var cardText = cardBody[0].getElementsByClassName('card-text');
        var cardImage = cards[index].getElementsByClassName('card-img-top');
        var cardAction = cards[index].getElementsByClassName('card-action');

        //post._embedded['wp:featuredmedia']['0'].source_url

        cardTitle[0].innerHTML = post.post_title;
        cardText[0].innerHTML = post.short_copy;
        cardImage[0].src = post.image_url;
        cardImage[0].alt = post.post_title;
        cardAction[0].innerHTML = "Read More";
        cardAction[0].setAttribute('href', post.link);
        cardAction[0].classList.remove('placeholder');
        console.log('Title:', post.post_title);
        console.log('Content:', post.short_copy);
        //console.log('Author ID:', post.author);
        console.log('---------------------');
      }
    });

    // ANIMATE CARDS fix me
    var timelines = {};
    document.querySelectorAll('.gcrow').forEach(function (row, index) {
      var rowID = row.id;
      var timelineName = "timeline_" + index;
      timelines[timelineName] = gsap.timeline({
        scrollTrigger: {
          trigger: "#" + rowID,
          // Use the specific container as the trigger
          start: "top 30%",
          // Adjust as needed
          toggleActions: "play reverse play reverse" // Customize as needed
        }
      }).to("#" + rowID + " .card", {
        opacity: 1,
        stagger: 0.15,
        y: '0',
        ease: "power4.out",
        filter: 'blur(0px)'
      });
      ScrollTrigger.refresh();
    });
  }).catch(function (error) {
    console.error('Error:', error);
  });

  // FRONTIERS
  var endpointUrlF = 'https://kenaninstitute.unc.edu/wp-json/custom/v1/ar25frontiers';
  // Make the request
  fetch(endpointUrlF).then(function (response) {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json(); // Parse the response body as JSON
  }).then(function (data) {
    // Process the data
    data.forEach(function (post, index) {
      var cards = document.getElementsByClassName('card frontiers');
      if (cards.length) {
        var cardBody = cards[index].getElementsByClassName('card-body');
        var cardTitle = cardBody[0].getElementsByClassName('card-title');
        var cardText = cardBody[0].getElementsByClassName('card-text');
        var cardImage = cards[index].getElementsByClassName('card-img-top');
        var cardAction = cards[index].getElementsByClassName('card-action');

        //post._embedded['wp:featuredmedia']['0'].source_url

        cardTitle[0].innerHTML = post.post_title;
        cardText[0].innerHTML = post.short_copy;
        cardImage[0].src = post.image_url;
        cardImage[0].alt = post.post_title;
        cardAction[0].innerHTML = "Read More";
        cardAction[0].setAttribute('href', post.link);
        cardAction[0].classList.remove('placeholder');
        console.log('Title:', post.post_title);
        console.log('Content:', post.short_copy);
        //console.log('Author ID:', post.author);
        console.log('---------------------');
      }
    });

    // ANIMATE CARDS fix me
    var ftimelines = {};
    document.querySelectorAll('.frow').forEach(function (row, index) {
      var rowID = row.id;
      var timelineName = "ftimeline_" + index;
      ftimelines[timelineName] = gsap.timeline({
        scrollTrigger: {
          trigger: "#" + rowID,
          // Use the specific container as the trigger
          start: "top 30%",
          // Adjust as needed
          toggleActions: "play reverse play reverse" // Customize as needed
        }
      }).to("#" + rowID + " .card", {
        opacity: 1,
        stagger: 0.25,
        y: '0',
        ease: "power2.out",
        filter: 'blur(0px)'
      });
      ScrollTrigger.refresh();
    });
  });

  // FRONTIERS
  var endpointUrlFe = 'https://kenaninstitute.unc.edu/wp-json/custom/v1/ar24frontiers';
  // Make the request
  fetch(endpointUrlF).then(function (response) {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json(); // Parse the response body as JSON
  }).then(function (data) {
    // Process the data
    data.forEach(function (post, index) {
      var cards = document.getElementsByClassName('card fellows');
      if (cards.length) {
        var cardBody = cards[index].getElementsByClassName('card-body');
        var cardTitle = cardBody[0].getElementsByClassName('card-title');
        var cardText = cardBody[0].getElementsByClassName('card-text');
        var cardImage = cards[index].getElementsByClassName('card-img-top');
        var cardAction = cards[index].getElementsByClassName('card-action');

        //post._embedded['wp:featuredmedia']['0'].source_url

        cardTitle[0].innerHTML = post.post_title;
        cardText[0].innerHTML = post.short_copy;
        cardImage[0].src = post.image_url;
        cardImage[0].alt = post.post_title;
        cardAction[0].innerHTML = "Read More";
        cardAction[0].setAttribute('href', post.link);
        cardAction[0].classList.remove('placeholder');
        console.log('Title:', post.post_title);
        console.log('Content:', post.short_copy);
        //console.log('Author ID:', post.author);
        console.log('---------------------');
      }
    });

    // ANIMATE CARDS fix me
    var ftimelines = {};
    document.querySelectorAll('.ferow').forEach(function (row, index) {
      var rowID = row.id;
      var timelineName = "fetimeline_" + index;
      ftimelines[timelineName] = gsap.timeline({
        scrollTrigger: {
          trigger: "#" + rowID,
          // Use the specific container as the trigger
          start: "top 30%",
          // Adjust as needed
          toggleActions: "play reverse play reverse" // Customize as needed
        }
      }).to("#" + rowID + " .card", {
        opacity: 1,
        stagger: 0.25,
        y: '0',
        ease: "power2.out",
        filter: 'blur(0px)'
      });
      ScrollTrigger.refresh();
    });
  });

  // AGP
  var endpointUrlAGP = 'https://kenaninstitute.unc.edu/wp-json/custom/v1/ar25AGP';
  // Make the request
  fetch(endpointUrlAGP).then(function (response) {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json(); // Parse the response body as JSON
  }).then(function (data) {
    // Process the data
    data.forEach(function (post, index) {
      var cards = document.getElementsByClassName('card agp');
      if (cards.length) {
        var cardBody = cards[index].getElementsByClassName('card-body');
        var cardTitle = cardBody[0].getElementsByClassName('card-title');
        var cardText = cardBody[0].getElementsByClassName('card-text');
        var cardImage = cards[index].getElementsByClassName('card-img-top');
        var cardAction = cards[index].getElementsByClassName('card-action');

        //post._embedded['wp:featuredmedia']['0'].source_url

        cardTitle[0].innerHTML = post.post_title;
        cardText[0].innerHTML = post.short_copy;
        cardImage[0].src = post.image_url;
        cardImage[0].alt = post.post_title;
        cardAction[0].innerHTML = "Read More";
        cardAction[0].setAttribute('href', post.link);
        cardAction[0].classList.remove('placeholder');
        console.log('Title:', post.post_title);
        console.log('Content:', post.short_copy);
        //console.log('Author ID:', post.author);
        console.log('---------------------');
      }
    });

    // ANIMATE CARDS fix me
    var ftimelines = {};
    document.querySelectorAll('.frow').forEach(function (row, index) {
      var rowID = row.id;
      var timelineName = "ftimeline_" + index;
      ftimelines[timelineName] = gsap.timeline({
        scrollTrigger: {
          trigger: "#" + rowID,
          // Use the specific container as the trigger
          start: "top 30%",
          // Adjust as needed
          toggleActions: "play reverse play reverse" // Customize as needed
        }
      }).to("#" + rowID + " .card", {
        opacity: 1,
        stagger: 0.25,
        y: '0',
        ease: "power2.out",
        filter: 'blur(0px)'
      });
      ScrollTrigger.refresh();
    });
  });

  // Research
  var endpointUrlResearch = 'https://kenaninstitute.unc.edu/wp-json/custom/v1/ar25Research';
  // Make the request
  fetch(endpointUrlResearch).then(function (response) {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json(); // Parse the response body as JSON
  }).then(function (data) {
    // Process the data
    data.forEach(function (post, index) {
      var cards = document.getElementsByClassName('card translating');
      if (cards.length) {
        var cardBody = cards[index].getElementsByClassName('card-body');
        var cardTitle = cardBody[0].getElementsByClassName('card-title');
        var cardText = cardBody[0].getElementsByClassName('card-text');
        var cardImage = cards[index].getElementsByClassName('card-img-top');
        var cardAction = cards[index].getElementsByClassName('card-action');

        //post._embedded['wp:featuredmedia']['0'].source_url

        cardTitle[0].innerHTML = post.post_title;
        cardText[0].innerHTML = post.short_copy;
        cardImage[0].src = post.image_url;
        cardImage[0].alt = post.post_title;
        cardAction[0].innerHTML = "Read More";
        cardAction[0].setAttribute('href', post.link);
        cardAction[0].classList.remove('placeholder');
        console.log('Title:', post.post_title);
        console.log('Content:', post.short_copy);
        //console.log('Author ID:', post.author);
        console.log('---------------------');
      }
    });

    // ANIMATE CARDS fix me
    var ftimelines = {};
    document.querySelectorAll('.frrow').forEach(function (row, index) {
      var rowID = row.id;
      var timelineName = "ftimeline_" + index;
      ftimelines[timelineName] = gsap.timeline({
        scrollTrigger: {
          trigger: "#" + rowID,
          // Use the specific container as the trigger
          start: "top 30%",
          // Adjust as needed
          toggleActions: "play reverse play reverse" // Customize as needed
        }
      }).to("#" + rowID + " .card", {
        opacity: 1,
        stagger: 0.25,
        y: '0',
        ease: "power2.out",
        filter: 'blur(0px)'
      });
      ScrollTrigger.refresh();
    });
  });
}

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.grandchallenge = grandchallenge;
function grandchallenge() {
  console.log('grandchallenge');
  var grandchallengecontainer = gsap.timeline({
    scrollTrigger: {
      trigger: "#grandchallenge-container",
      scrub: 2,
      pin: true
      // start: "top 10px", // when top of the element hits 20% of viewport
      // toggleActions: "play reverse play reverse", // Customize as needed
    }
  }).to("#grandchallenge-background", {
    opacity: '1',
    filter: 'blur(0px)',
    duration: 4
  }, 0).to("#grandchallenge-image img", {
    clipPath: "polygon(100% 0%, 0% 20%, 0% 90%, 100% 70%)",
    delay: 2,
    duration: 2
  }, 0).to("#grandchallenge-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.15,
    delay: 0.25,
    ease: 'power4.out'
  }, 0).to("#grandchallenge-title p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.5,
    delay: 0.45,
    ease: 'power4.out'
  }, 0).to("#grandchallenge-title h3", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.35,
    ease: 'power4.out'
  }, 0).to("#grandchallenge-title h2", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    delay: 0.25,
    duration: 0.5,
    ease: 'power4.out'
  }, 0).to("#grandchallenge-image img", {
    clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
    duration: 5
  })
  // .to(
  //     "#grandchallenge-title h1",
  //     {
  //         opacity: '0',
  //         filter: 'blur(5px)',
  //         duration: 4,
  //         ease: 'power4.out',
  //         y: '-100',
  //     },4
  // )
  .to("#grandchallenge-title h3", {
    opacity: '0',
    filter: 'blur(5px)',
    duration: 4,
    ease: 'power4.out',
    y: '-200'
  }, 4)
  // .to(
  //     "#grandchallenge-title h2",
  //     {
  //         opacity: '0',
  //         filter: 'blur(5px)',
  //         duration: 4,
  //         ease: 'power4.out',
  //         y: '-50',
  //     },4
  // )
  .to("#grandchallenge-title p", {
    opacity: '0',
    filter: 'blur(5px)',
    duration: 4,
    ease: 'power4.out',
    y: '-300'
  }, 4);
  var gccontent = gsap.timeline({
    scrollTrigger: {
      trigger: "#gc-content",
      pin: true,
      scrub: 2
    }
  }).from("#gc-content-text p", {
    ease: 'power4.out',
    duration: 2,
    opacity: 0,
    filter: 'blur(5px)',
    y: '+=800',
    stagger: 0.25
  }).from("#gc-content-vid", {
    ease: 'power4.out',
    duration: 2,
    opacity: 0,
    y: '+= 800'
  }, 0.15);
  var grandchallengeexplore = gsap.timeline({
    scrollTrigger: {
      trigger: "#gc-cards",
      start: "top 60%",
      toggleActions: "play reverse play reverse"
    }
  }).from("#gc-content-explore", {
    ease: 'power4.out',
    duration: 2,
    opacity: 0,
    y: '+= 400'
  });
}

},{}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.happy = happy;
function happy() {
  console.log('HAPPY ECONOMIST');
  var eventcontainer = gsap.timeline({
    scrollTrigger: {
      trigger: "#happy-container",
      scrub: 2,
      pin: true,
      start: "top top"
    }
  }).to("#happy-background", {
    opacity: '1',
    filter: 'blur(0px)'
  }, 0).to("#happy-image img", {
    clipPath: "polygon(100% 0%, 0% 20%, 0% 90%, 100% 70%)",
    delay: 2
  }, 0).to("#happy-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    delay: 0.25,
    ease: 'power4.out'
  }, 0).to("#happy-title p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.5,
    delay: 0.45,
    ease: 'power4.out',
    stagger: 0.25
  }, 0).to("#happy-image img", {
    clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
    duration: 5
  }).to("#happy-title p", {
    opacity: '0',
    filter: 'blur(5px)',
    duration: 4,
    ease: 'power4.out',
    y: '-200'
  }, 4);
  var happycontainerX = gsap.timeline({
    scrollTrigger: {
      trigger: "#happy-content",
      scrub: 2,
      pin: true
    }
  }).to(".happy, #happy-content p, #happy-content h3", {
    opacity: '1',
    y: '0',
    filter: 'blur(0px)',
    stagger: 0.25
  }, 0);
}

},{}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.introvideo = introvideo;
function introvideo() {
  console.log('intro video');
  var videoPlayBtns = document.querySelectorAll('.play-video');
  videoPlayBtns.forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      // Hide parent element safely
      if (event.currentTarget.parentElement) {
        event.currentTarget.parentElement.style.display = "none";
      }

      // Find the first iframe (ensure it exists)
      var iframe = event.currentTarget.parentElement.parentElement.getElementsByTagName("iframe")[0]; // Adjust if needed
      if (iframe) {
        var iframeWindow = iframe.contentWindow;
        iframeWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      } else {
        console.log('no iframe');
      }
    });
  });
  window.addEventListener("scroll", function () {
    // Get all YouTube iframes
    var iframes = document.querySelectorAll("iframe[src*='youtube.com/embed']");
    iframes.forEach(function (iframe) {
      if (iframe.contentWindow) {
        iframe.contentWindow.postMessage('{"event": "command", "func": "pauseVideo", "args": ""}', '*');
      }
    });
  });
}

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.letter = letter;
function letter() {
  console.log('letter');
  var letter = gsap.timeline({
    scrollTrigger: {
      trigger: "#landing-letter",
      scrub: 1,
      pin: true
    }
  }).to("#letter-title", {
    y: 0,
    opacity: 1,
    filter: "blur(0px)",
    duration: 3
  }).to("#landing-background img", {
    filter: "blur(5px)",
    duration: 3
  }, 0).to("#mail", {
    y: "0",
    opacity: 1,
    filter: "blur(0px)",
    duration: 3
  }, 0).to("#mail-middle", {
    y: "-20",
    duration: 3
  }, 0).to("#mail", {
    scaleX: 55,
    scaleY: 55,
    delay: 3,
    duration: 10
  }, 0.5).to("#landing-contents", {
    y: 0,
    opacity: 1,
    filter: "blur(0px)",
    delay: 3,
    duration: 3
  }, 0.5).to("#landing-contents", {
    y: "-=100",
    filter: "blur(5px)",
    duration: 1
  });
}

},{}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lettertext = lettertext;
function lettertext() {
  console.log('letter text');
  var lettertext = gsap.timeline({
    scrollTrigger: {
      trigger: "#letter-text",
      start: "top 30%",
      // when top of the element hits 20% of viewport
      toggleActions: "play reverse play reverse" // Customize as needed
    }
  }).to("#letter-building", {
    y: "0",
    opacity: "1",
    filter: "blur(0px)",
    ease: "power1.out"
  }).to("#letter-text-contents h3", {
    y: "0",
    opacity: "1",
    filter: "blur(0px)",
    ease: "power1.out"
  }).to(".letter-text-p", {
    y: "0",
    opacity: "1",
    filter: "blur(0px)",
    ease: "power1.in"
  });
}

},{}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ncgrowth = ncgrowth;
function ncgrowth() {
  console.log('NCGROWTH');
  var ncgrowthcontainer = gsap.timeline({
    scrollTrigger: {
      trigger: "#ncgrowth-container",
      scrub: 2,
      pin: true,
      start: "top top"
    }
  }).to("#ncgrowth-background", {
    opacity: '1',
    filter: 'blur(0px)'
  }, 0).to("#ncgrowth-image img", {
    clipPath: "polygon(100% 0%, 0% 20%, 0% 90%, 100% 70%)",
    delay: 2
  }, 0).to("#ncgrowth-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    delay: 0.25,
    ease: 'power4.out'
  }, 0).to("#ncgrowth-title p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    delay: 0.45,
    stagger: 0.5,
    ease: 'power4.out'
  }, 0).to("#ncgrowth-image img", {
    clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
    duration: 5
  }).to("#ncgrowth-title p", {
    opacity: '0',
    filter: 'blur(5px)',
    duration: 4,
    ease: 'power4.out',
    y: '-200'
  }, 4);
  var timelines = {};
  document.querySelectorAll('.ncgrow').forEach(function (row, index) {
    var rowID = row.id;
    var timelineName = "timeline_" + index;
    timelines[timelineName] = gsap.timeline({
      scrollTrigger: {
        trigger: "#" + rowID,
        // Use the specific container as the trigger
        start: "top 30%",
        // Adjust as needed
        toggleActions: "play reverse play reverse" // Customize as needed
      }
    }).to("#" + rowID + " .card", {
      opacity: 1,
      stagger: 0.15,
      y: '0',
      ease: "power4.out",
      filter: 'blur(0px)'
    });
    ScrollTrigger.refresh();
  });
  var ncgrowthcontainer3 = gsap.timeline({
    scrollTrigger: {
      trigger: "#ncgrowth-content2",
      start: "top 40%",
      toggleActions: "play reverse play reverse" // Customize as needed
    }
  }).to('#ncgrowth-content-inner h3, #ncgrowth-content-inner p', {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    stagger: 0.25
  });
}

},{}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newfrontiers = newfrontiers;
function newfrontiers() {
  console.log('2025 frontiers');
  var newfrontierscontainer = gsap.timeline({
    scrollTrigger: {
      trigger: "#newfrontiers-container",
      scrub: 2,
      pin: true,
      start: "top top"
    }
  }).to("#newfrontiers-background", {
    opacity: '1',
    filter: 'blur(0px)',
    duration: 4
  }, 0).to("#newfrontiers-image img", {
    clipPath: "polygon(100% 0%, 0% 20%, 0% 90%, 100% 70%)",
    delay: 2,
    duration: 2
  }, 0).to("#newfrontiers-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.15,
    delay: 0.25,
    ease: 'power4.out'
  }, 0).to("#newfrontiers-title p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.5,
    delay: 0.45,
    ease: 'power4.out',
    stagger: 0.25
  }, 0).to("#newfrontiers-title h2", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    delay: 0.25,
    duration: 0.5,
    ease: 'power4.out'
  }, 0).to("#newfrontiers-image img", {
    clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
    duration: 5
  }).to("#newfrontiers-title p", {
    opacity: '0',
    filter: 'blur(5px)',
    duration: 4,
    ease: 'power4.out',
    y: '-300'
  }, 4);
  var newfrontierscontainer2 = gsap.timeline({
    scrollTrigger: {
      trigger: "#newfrontiers-content",
      scrub: 2,
      pin: true,
      start: "top top"
    }
  }).to("#newfrontiers-content h3, #newfrontiers-content p, .newfrontiers-content-vid", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 2,
    stagger: 0.25,
    ease: 'power4.out'
  }, 1);
}

},{}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newgrandchallenge = newgrandchallenge;
function newgrandchallenge() {
  console.log('2025 grandchallenge');
  var newgrandchallengecontainer = gsap.timeline({
    scrollTrigger: {
      trigger: "#newgrandchallenge-container",
      scrub: 2,
      pin: true,
      start: "top top"
    }
  }).to("#newgrandchallenge-background", {
    opacity: '1',
    filter: 'blur(0px)',
    duration: 4
  }, 0).to("#newgrandchallenge-image img", {
    clipPath: "polygon(100% 0%, 0% 20%, 0% 90%, 100% 70%)",
    delay: 2,
    duration: 2
  }, 0).to("#newgrandchallenge-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.15,
    delay: 0.25,
    ease: 'power4.out'
  }, 0).to("#newgrandchallenge-title h3", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.35,
    ease: 'power4.out'
  }, 0).to("#newgrandchallenge-title h2", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    delay: 0.25,
    duration: 0.5,
    ease: 'power4.out'
  }, 0).to("#newgrandchallenge-image img", {
    clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
    duration: 5
  }).to("#newgrandchallenge-title h3", {
    opacity: '0',
    filter: 'blur(5px)',
    duration: 4,
    ease: 'power4.out',
    y: '-200'
  }, 4);
  var newgrandchallengecontainer2 = gsap.timeline({
    scrollTrigger: {
      trigger: "#newgrandchallenge-content",
      start: "top 40%",
      toggleActions: "play reverse play reverse" // Customize as needed
    }
  }).to('#newgrandchallenge-content p', {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    stagger: 0.25
  });
}

},{}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resaearch = resaearch;
function resaearch() {
  console.log('RESEARCH');
  var researchcontainer = gsap.timeline({
    scrollTrigger: {
      trigger: "#research-container",
      scrub: 2,
      pin: true,
      start: "top top"
    }
  }).to("#research-background", {
    opacity: '1',
    filter: 'blur(0px)',
    duration: 4
  }, 0).to("#research-image img", {
    clipPath: "polygon(100% 0%, 0% 20%, 0% 90%, 100% 70%)",
    delay: 2,
    duration: 2
  }, 0).to("#research-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.15,
    delay: 0.25,
    ease: 'power4.out'
  }, 0).to("#research-title p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 0.5,
    delay: 0.45,
    ease: 'power4.out'
  }, 0).to("#research-image img", {
    clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
    duration: 5
  });
  var timelines = {};
  document.querySelectorAll('.prow').forEach(function (row, index) {
    var rowID = row.id;
    var timelineName = "timeline_" + index;
    timelines[timelineName] = gsap.timeline({
      scrollTrigger: {
        trigger: "#" + rowID,
        // Use the specific container as the trigger
        start: "top 30%",
        // Adjust as needed
        toggleActions: "play reverse play reverse" // Customize as needed
      }
    }).to("#" + rowID + " .card", {
      opacity: 1,
      stagger: 0.15,
      y: '0',
      ease: "power4.out",
      filter: 'blur(0px)'
    });
    ScrollTrigger.refresh();
  });
}

},{}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scholars = scholars;
function scholars() {
  console.log('SCHOLARS');
  var scholarscontainer = gsap.timeline({
    scrollTrigger: {
      trigger: "#scholars-container",
      scrub: 2,
      pin: true,
      start: "top top"
    }
  }).to("#scholars-background", {
    opacity: '1',
    filter: 'blur(0px)'
  }, 0).to("#scholars-image img", {
    clipPath: "polygon(100% 0%, 0% 20%, 0% 90%, 100% 70%)",
    delay: 2
  }, 0).to("#scholars-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    delay: 0.25,
    ease: 'power4.out'
  }, 0).to("#scholars-title p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    delay: 0.45,
    stagger: 0.5,
    ease: 'power4.out'
  }, 0).to("#scholars-image img", {
    clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
    duration: 5
  });
  var scholarscontainer2 = gsap.timeline({
    scrollTrigger: {
      trigger: "#scholars-content",
      start: "top 40%",
      // when top of the element hits 20% of viewport
      toggleActions: "play reverse play reverse" // Customize as needed
    }
  }).to("#scholars-content .left p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    ease: 'power4.out',
    stagger: 0.25
  }).to("#scholars-content .button", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    ease: 'power4.out',
    stagger: 0.25
  }, 0.15);
}

},{}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trends = trends;
function trends() {
  console.log('trends');
  var trends = gsap.timeline({
    scrollTrigger: {
      trigger: "#landing-trends-contents",
      start: "top 20%",
      // when top of div hits center of viewport
      toggleActions: "play"
    }
  }).to("#trends-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 1,
    ease: 'power4.out'
  }).to("#trends-title p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    duration: 1,
    ease: 'power4.out'
  }, 0.25).to(".trend", {
    x: '0',
    duration: 1,
    stagger: 0.25,
    ease: 'power4.out'
  }, 0.5);
  var eaccontainer4 = gsap.timeline({
    scrollTrigger: {
      trigger: "#trends-btn-container",
      start: "top 50%",
      toggleActions: "play reverse play reverse" // Customize as needed
    }
  }).to('#trends-btn', {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)'
  });
}

},{}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wealth = wealth;
function wealth() {
  console.log('WEALTH');
  var wealthcontainer = gsap.timeline({
    scrollTrigger: {
      trigger: "#wealth-container",
      scrub: 2,
      pin: true,
      start: "top top"
    }
  }).to("#wealth-background", {
    opacity: '1',
    filter: 'blur(0px)'
  }, 0).to("#wealth-image img", {
    clipPath: "polygon(100% 0%, 0% 20%, 0% 90%, 100% 70%)",
    delay: 2
  }, 0).to("#wealth-title h1", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    delay: 0.25,
    ease: 'power4.out'
  }, 0)
  // .to(
  //     "#wealth-title p",
  //     {
  //         y: '0',
  //         opacity: '1',
  //         filter: 'blur(0px)',
  //         delay: 0.45,
  //         stagger: 0.5,
  //         ease: 'power4.out',
  //     },0
  // )    
  .to("#wealth-image img", {
    clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
    duration: 5
  });
  // .to(
  //     "#wealth-title p",
  //     {
  //         opacity: '0',
  //         filter: 'blur(5px)',
  //         duration: 4,
  //         ease: 'power4.out',
  //         y: '-200',
  //     },4
  // )

  var timelines = {};
  document.querySelectorAll('.prow').forEach(function (row, index) {
    var rowID = row.id;
    var timelineName = "timeline_" + index;
    timelines[timelineName] = gsap.timeline({
      scrollTrigger: {
        trigger: "#" + rowID,
        // Use the specific container as the trigger
        start: "top 30%",
        // Adjust as needed
        toggleActions: "play reverse play reverse" // Customize as needed
      }
    }).to("#" + rowID + " .card", {
      opacity: 1,
      stagger: 0.15,
      y: '0',
      ease: "power4.out",
      filter: 'blur(0px)'
    });
    ScrollTrigger.refresh();
  });
  var wealth2 = gsap.timeline({
    scrollTrigger: {
      trigger: "#wealth-content",
      start: "top 40%",
      // when top of the element hits 20% of viewport
      toggleActions: "play reverse play reverse" // Customize as needed
    }
  }).to("#wealth-content .left p", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    ease: 'power4.out',
    stagger: 0.25
  }).to("#wealth-content .button", {
    y: '0',
    opacity: '1',
    filter: 'blur(0px)',
    ease: 'power4.out',
    stagger: 0.25
  }, 0.15);
}

},{}]},{},[1]);
